module.exports = __webpack_public_path__ + "static/media/richard.fadc164d.png";